import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Account pages
export const AccountGeneralPage = lazy(
  () =>
    retry(() => import('@/pages/account/account-general')) as Promise<
      typeof import('@/pages/account/account-general')
    >
);

export const AccountSecurityPage = lazy(
  () =>
    retry(() => import('@/pages/account/account-security')) as Promise<
      typeof import('@/pages/account/account-security')
    >
);

export const AccountNotificationsPage = lazy(
  () =>
    retry(() => import('@/pages/account/account-notifications')) as Promise<
      typeof import('@/pages/account/account-notifications')
    >
);
